import Image from 'next/image';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import Link from 'next/link';
import { getStaticAssetUrl } from 'utils/url';
interface headerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export const HeaderTopNav = ({ onOpenChange, open }: headerProps) => {
  return (
    <>
      <div className='w-full'>
        <Link href='/'>
          <Image
            className='h-[70px]'
            alt='Singularity Finance'
            src={getStaticAssetUrl(
              '/sfi/static/logo/singularity_finance_full_logo.svg'
            )}
            width={150}
            height={50}
          />
        </Link>
      </div>
      <div onClick={() => onOpenChange(!open)}>
        {open ? (
          <Icon className='mt-3' icon='close' color='white' />
        ) : (
          <Icon icon='menu' color='white' />
        )}
      </div>
    </>
  );
};
